<template>
  <div class="updateImg"  @click="toDatadetails(335)">
    <img
      v-if="language == 'zh'"
      src="@/assets/image/DataSearch/updateImg1.png"
      alt=""
    />
     <img
      v-if="language == 'fran'"
      src="@/assets/image/DataSearch/updateImg3.png"
      alt=""
    />
    <img v-else src="@/assets/image/DataSearch/updateImg2.png" alt="" />
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  methods:{
     toDatadetails(dataId) {
      // console.log(item)
      this.$router.push(`/datadetails?dataId=${dataId}`);
    },
  }
};
</script>

<style lang="scss" scoped>
.updateImg {
  width: 100%;
  margin: auto;
  height: 132px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    cursor: pointer;
    object-fit: cover;
    transition: 0.2s;
    // &:hover {
    //   transition: 0.2s;
    //   transform: scale(0.95);
    // }
  }
}
</style>